import React from 'react';
import {
    basicColumnDef,
    choiceListColumnDef,
    dateColumnDef,
    timeColumnDef,
    idColumnDef
} from '../common/FilteredTable/tableAndFilterHelpers';
import ColumnTypeFormatCompanyName from '../common/Table/ColumnTypeFormatCompanyName';

const communication = {
    id: idColumnDef('id', 'communicationId'),
    note: {
        ...basicColumnDef('Details', 'note'),
        type: 'textarea',
        mapToDisplayedValue: (resources, values) => (values && values.note ? values.note.substring(0, 100).trim() : '')
    },
    action: {
        ...choiceListColumnDef('Action', 'action', 'communicationAction'),
        emptyOption: 'Select an action...',
        searchable: true
    },
    category: {
        ...basicColumnDef('Category', 'category', 'communicationCategory'),        
    },
    meetingMode: {
        ...choiceListColumnDef('Meeting Mode', 'meetingMode', 'communicationMeetingMode'),
        emptyOption: 'Select a meeting mode...',
        searchable: true
    },
    eventType: {
        ...choiceListColumnDef('Event Type', 'action', 'communicationEventType'),
        emptyOption: 'Select an Action...'
    },
    companyName: {
        ...basicColumnDef('Company Name', 'companyName'),
        mapping: (resources, values) => (values && values.company ? values.company.descriptor : ''),
        mapToDisplayedValue: (resources, values) => <ColumnTypeFormatCompanyName values={values} />
    },
    personId: {
        ...choiceListColumnDef('Person', 'personId', 'peopleOptions'),
        emptyOption: 'Select a Person...',
        noOptionsText: 'No people in company'
    },
    opportunityId: {
        ...choiceListColumnDef('Opportunity', 'opportunityId', 'opportunityOptions'),
        emptyOption: 'Select an Opportunity...',
        noOptionsText: 'No opportunities in company'
    },
    subject: {
        ...basicColumnDef('Subject', 'subject'),
        searchable: true
    },
    status: {
        ...choiceListColumnDef('Status', 'status', 'communicationStatus'),
        emptyOption: 'Select a status...'
    },
    assigneeId: {
        ...choiceListColumnDef('Assignee', 'assigneeId', 'communicationAssignee', {
            renderAsBasicText: true
        }),
        emptyOption: 'Select an assignee...',
        searchable: true,
        mapping: (resources, values) => (values && values.assigneeId ? values.assigneeId.toString() : '')
    },
    startDate: {
        ...dateColumnDef('Communication Date', 'startDate', true),
        searchable: true
    },
    startTime: {
        ...timeColumnDef('Meeting Time', 'startDate')
    },
    endDate: {
        ...dateColumnDef('Close Date', 'endDate')
    },
    activityRegarding: {
        ...choiceListColumnDef('Activity Regarding', 'activityRegarding', 'communicationActivityRegarding', {
            renderAsBasicText: true,
            displayEmptyAs: '-'
        }),
        emptyOption: 'Select an activity regarding...',
        searchable: true
    },
    notes: {
        ...basicColumnDef('Details', 'notes'),
        type: 'textarea'
    },
    location: {
        ...basicColumnDef('Location', 'location')
    }
};

export default communication;
